const initialDialogState = {
  dialogs: /* @__PURE__ */ new Map()
};
const dialogReducer = (previousState, action) => {
  switch (action.type) {
    case "openDialog": {
      const clone = new Map(previousState.dialogs);
      clone.set(action.dialogId, action.dialog);
      return { dialogs: clone };
    }
    case "closeDialog": {
      const clone = new Map(previousState.dialogs);
      return clone.delete(action.dialogId) ? { dialogs: clone } : previousState;
    }
    default:
      return previousState;
  }
};
export {
  dialogReducer,
  initialDialogState
};
//# sourceMappingURL=dialogReducer.js.map
